/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ConfigService } from 'src/app/service/config.service';

/**
 * Base service for Reporting Service API calls.
 * Auth headers are injected automatically by AuthInterceptor.
 */
@Injectable({
  providedIn: 'root',
})
export class ReportingApiService {
  private baseUrl: string;

  constructor(
    protected http: HttpClient,
    protected config: ConfigService,
  ) {
    this.baseUrl = this.config.appConfig.urlReportingServiceApi;
  }

  getUrl(endpoint: string): string {
    return `${this.baseUrl}${endpoint}`;
  }

  get<T>(endpoint: string, params?: Record<string, string>): Observable<T> {
    return this.http.get<T>(this.getUrl(endpoint), { params });
  }

  post<T>(endpoint: string, body: any): Observable<T> {
    return this.http.post<T>(this.getUrl(endpoint), body);
  }

  put<T>(endpoint: string, body: any): Observable<T> {
    return this.http.put<T>(this.getUrl(endpoint), body);
  }

  delete<T>(endpoint: string, params?: Record<string, string>): Observable<T> {
    return this.http.delete<T>(this.getUrl(endpoint), { params });
  }
}
